export { TelegramIcon } from './telegram';
export { YoutubeIcon } from './youtube';
export { VkIcon } from './vk';
export { WarningIcon } from './warning';
export { LogoIcon } from './logo';
export { LogoTextIcon } from './logo-text';
export { GlobalSimpleIcon } from './gloabl-simple';
export { SwordIcon } from './sword';
export { ShootingStarIcon } from './shooting-star';
export { HeartBreakIcon } from './heart-break';
export { FeatherIcon } from './feather';
export { ApproveIcon } from './approve';
export { CabinetIcon } from './cabinet';
export { CabinetWhiteIcon } from './cabinet-white';
export { CloseIcon } from './close';
export { CollectionsIcon } from './collections';
export { CommentsIcon } from './comments';
export { CommunityIcon } from './community';
export { EditIcon } from './edit';
export { LeftArrowIcon } from './left-arrow';
export { RightArrowIcon } from './right-arrow';
export { ChevronDownIcon } from './chevron-down';
export { LogoutIcon } from './logout';
export { LogoutWhiteIcon } from './logout-white';
export { ProfileIcon } from './profile';
export { ProfileWhiteIcon } from './profile-white';
export { RewardsIcon } from './rewards';
export { SettingsIcon } from './settings';
export { StatisticsIcon } from './statistics';
export { UploadIcon } from './upload';
export { ArticlesCountIcon } from './articles-count';
export { WorksIcon } from './works';
